import { StarFill } from "react-bootstrap-icons";
import { formatDateTime } from "@utils";

// The reconciled label as a timeline entry. Returns an empty list when the transaction carries
// no active label, so callers can spread it unconditionally. The name is resolved by the caller
// (the API returns a guid) and may be absent while that lookup is in flight.
export const reconciledTimelineEntry = (reconciledLabel, reconciledByName) =>
  reconciledLabel
    ? [
        {
          title: "Reconciled in ERP",
          subTitle: [formatDateTime(reconciledLabel.updatedOn), reconciledByName]
            .filter(Boolean)
            .join(" - "),
          date: reconciledLabel.updatedOn,
          nodeContent: { icon: StarFill, color: "amber" },
        },
      ]
    : [];
